// Action Types
import { LOGIN_USER, FETCH_PROFILE, FETCH_USER_LOCATION } from './actionTypes';


const initialState = {
  gettingUserLocation: false,
  userLocation: null,
  loggingIn: false,
  loggedIn: false,
  token: '',
  profile: null
};

// eslint-disable-next-line
export default function authenticationReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_USER_LOCATION.request(): {
      return { ...state, gettingUserLocation: true, userLocation: null };
    }

    case FETCH_USER_LOCATION.success(): {
      return { ...state, gettingUserLocation: false, userLocation: action.payload };
    }

    case FETCH_USER_LOCATION.error(): {
      return { ...state, gettingUserLocation: false, error: action.payload };
    }

    case LOGIN_USER.request(): {
      return { ...state, loggingIn: true, loggedIn: false, token: '' };
    }

    case LOGIN_USER.success(): {
      return { ...state, loggingIn: false, loggedIn:true, token: action.payload };
    }

    case LOGIN_USER.error(): {
      return { ...state, loggingIn: false, error: action.payload };
    }

    case FETCH_PROFILE.request(): {
      return { ...state, profile: null };
    }

    case FETCH_PROFILE.success(): {
      return { ...state, profile: action.payload };
    }

    case FETCH_PROFILE.error(): {
      return { ...state, error: action.payload };
    }

    default:
      return state;
  }
}
